// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Samtale',
  working: 'Arbejder på det…',
  stopped: 'Stoppet. Intet er ændret.',
  step_stopped: 'Stoppet',
  not_sent: 'Ikke sendt',
  failed: {
    text: 'Noget gik galt hos mig, så intet er ændret. Prøv igen om et øjeblik.',
    retry: 'Prøv igen',
  },
  question: {
    type_answer: 'Eller skriv dit svar nedenfor.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo er ikke tilgængelig lige nu.',
      assistant: 'Assistenten er ikke tilgængelig lige nu.',
    },
    text: 'Intet er ændret, og resten af dashboardet fungerer som normalt. Prøv igen om nogle minutter.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'I dag',
  when: {
    today: 'I dag, {{time}}',
    yesterday: 'I går, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Ny chat for {{restaurant}}. {{previous}}s chats finder du under Chats, når du vender tilbage til den.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: '{{name}}s chat (FoodAmigos)',
      owner: '{{name}}s chat (ejer)',
      staff: '{{name}}s chat (personale)',
      partner: '{{name}}s chat (partner)',
      other: '{{name}}s chat',
      unnamed: 'En andens chat',
    },
    text: '{{name}}s chat. Du kan læse den, men ikke svare eller godkende dens kort.',
    text_unnamed: 'En andens chat. Du kan læse den, men ikke svare eller godkende dens kort.',
    new_chat: 'Ny chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Denne chat er afsluttet. Start en ny chat for at fortsætte.',
    new_chat: 'Ny chat',
    moved_line: 'Ny chat, fordi den forrige var afsluttet',
  },
  composer: {
    label: 'Besked',
    placeholder: 'Stil et spørgsmål, eller beskriv en ændring',
    placeholder_answer: 'Skriv dit svar',
    hint: 'Enter for at sende · Skift+Enter for ny linje',
  },
  table: {
    show_all: 'Vis alle {{count}} rækker',
    show_fewer: 'Vis færre',
  },
  steps: {
    areas: 'Tjekker, hvad jeg kan hjælpe med her',
    area_describe: 'Ser på {{area}}',
    read: 'Læser dine data',
    propose: 'Forbereder ændringen',
    change_set_get: 'Tjekker ændringen',
    gap_record: 'Noterer dette til vores team',
    research: 'Undersøger, hvordan det fungerer',
    screen_find: 'Finder den rigtige side',
    file_read: 'Læser din fil',
    shop_check: 'Tjekker din shop',
    area_describe_other: 'Ser på dette område',
    other: 'Tjekker noget',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Kunne ikke læse menuen',
      hours: 'Kunne ikke læse åbningstiderne',
      order_settings: 'Kunne ikke læse bestillingsindstillingerne',
      my_info: 'Kunne ikke læse dine oplysninger',
      marketing: 'Kunne ikke læse din markedsføring',
      gift_cards: 'Kunne ikke læse gavekortene',
      reports: 'Kunne ikke læse dine tal',
      other: 'Kunne ikke læse dine data',
    },
    propose: {
      menu: 'Kunne ikke forberede menuændringen',
      hours: 'Kunne ikke forberede ændringen af åbningstiderne',
      order_settings: 'Kunne ikke forberede ændringen af bestillingsindstillingerne',
      my_info: 'Kunne ikke forberede ændringen af dine oplysninger',
      marketing: 'Kunne ikke forberede markedsføringsændringen',
      gift_cards: 'Kunne ikke forberede gavekortændringen',
      other: 'Kunne ikke forberede ændringen',
    },
    change_set_get: { other: 'Kunne ikke kontrollere ændringen' },
    research: { other: 'Kunne ikke finde ud af, hvordan det fungerer' },
    screen_find: { other: 'Kunne ikke finde siden' },
    file_read: { other: 'Kunne ikke læse din fil' },
    shop_check: { other: 'Kunne ikke åbne din shop' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'menuen',
    hours: 'åbningstiderne',
    order_settings: 'bestillingsindstillingerne',
    my_info: 'oplysninger om din restaurant',
    marketing: 'marketing',
    reports: 'rapporterne',
  },
};
